<template>
  <AePageLayout v-model:sidebar-collapsed="sidebarCollapsed" v-model:mobile-open="sidebarMobileOpen">
    <template #sidebar>
      <AeSidebar
        v-model:collapsed="sidebarCollapsed"
        :items="sidebarItems"
        :active-item="activeItem"
        @navigate="handleNavigate"
        @close="sidebarMobileOpen = false"
      >
        <template #header>
          <div class="sidebar-brand" :class="{ 'sidebar-brand--collapsed': sidebarCollapsed, 'sidebar-brand--has-square': showSidebarSquareLogo }">
            <img
              v-if="showSidebarLogo"
              class="sidebar-brand__logo sidebar-brand__logo--full"
              src="/logo-meteo.png"
              alt="Logo"
              @error="showSidebarLogo = false"
            />
            <img
              v-if="showSidebarSquareLogo"
              class="sidebar-brand__logo sidebar-brand__logo--square"
              src="/logo-meteo-square.png"
              alt="Logo"
              @error="showSidebarSquareLogo = false"
            />
          </div>
        </template>
      </AeSidebar>
    </template>

    <template #navbar>
      <AeNavbar
        title="Distribuzione dei dati meteo"
        @toggle-sidebar="sidebarMobileOpen = !sidebarMobileOpen"
      >
        <template #right>
          <!-- Pulsante login/logout -->
          <!-- <button v-if="!appStore.isAuthenticated" class="btn btn-sm btn-primary" @click="appStore.login()">
            Login
          </button> -->
          <AeButton v-if="!appStore.isAuthenticated" variant="primary" @click="appStore.login()">
            Login
          </AeButton>
          <div v-else class="d-flex align-items-center gap-2">
            <span class="user-name">{{ appStore.getUserName }}</span>
            <AeButton variant="primary"  @click="appStore.logout()">
              Logout
            </AeButton>
          </div>
        </template>
      </AeNavbar>
    </template>

    <!-- Slot di default: contenuto della pagina -->
    <slot />
  </AePageLayout>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore } from '../stores/app.js'
import { useSidebar } from '../composables/useSidebar.js'
import { AePageLayout, AeSidebar, AeNavbar, AeButton } from '@aevue/components'

const props = defineProps({
  activeItem: { type: String, default: '' },
  title: { type: String, default: null },
  navbarTitle: { type: String, default: null },
  sidebarItems: { type: Array, default: null },
})

const router = useRouter()
const appStore = useAppStore()
const { getSidebarItems } = useSidebar()

const sidebarCollapsed = ref(false)
const sidebarMobileOpen = ref(false)
const showSidebarLogo = ref(true)
const showSidebarSquareLogo = ref(true)

// Usa le voci passate come prop, o le voci default
const sidebarItems = props.sidebarItems ?? getSidebarItems()

function handleNavigate(item) {
  if (item.to) router.push(item.to)
  sidebarMobileOpen.value = false
}
</script>

<style scoped>
.sidebar-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.sidebar-brand__logo {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  object-fit: contain;
  display: block;
}

.sidebar-brand__logo--full {
  width: 100%;
  max-height: 56px;
}

.sidebar-brand__logo--square {
  display: none;
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 8px;
}

.sidebar-brand--collapsed .sidebar-brand__logo--full {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.sidebar-brand--collapsed.sidebar-brand--has-square .sidebar-brand__logo--full {
  display: none;
}

.sidebar-brand--collapsed.sidebar-brand--has-square .sidebar-brand__logo--square {
  display: block;
}

@media (min-width: 640px) and (max-width: 1023px) {
  .sidebar-brand.sidebar-brand--has-square .sidebar-brand__logo--full {
    display: none;
  }

  .sidebar-brand.sidebar-brand--has-square .sidebar-brand__logo--square {
    display: block;
  }

  .sidebar-brand:not(.sidebar-brand--has-square) .sidebar-brand__logo--full {
    width: 32px;
    height: 32px;
    object-fit: cover;
  }
}

.user-name {
  padding: 0.35rem 0.65rem;
}
</style>
